// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"5767b563","787":"3f61e249"}[chunkId] + ".chunk.js";
};